import { render, staticRenderFns } from "./InputNumeric.vue?vue&type=template&id=5490bc33&scoped=true&"
import script from "./InputNumeric.vue?vue&type=script&lang=js&"
export * from "./InputNumeric.vue?vue&type=script&lang=js&"
import style0 from "./InputNumeric.vue?vue&type=style&index=0&id=5490bc33&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5490bc33",
  null
  
)

export default component.exports